import IssueFilterPage from '../IssueFilterPage';
import IssueDetailsPage from '../IssueDetailsPage';
import IssueTablePage from '../IssueTablePage';

import './style.scss';
import { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { getJiraResponsibleTeam } from '../../services/jira.service';
import Split from '@uiw/react-split';
import CreateDocumentation from '../CreateDocumentationPage';

export const ResponsibleTeamContext = createContext<any[]>([]);

const IssuePage = () => {
    const [issueRefetch, setIssueRefetch] = useState<boolean>(false)
    const [createdMeetingId, setCreatedMeetingId] = useState<string | null>(null);
    const [responsibleTeamList, setResponsibleTeamList] = useState<any[]>([]);
    const userState = useSelector((state: RootState) => state.user);
    const userDetails = userState?.user;

    const getResponsibleTeamList = async () => {
        let responsibleTeamData: any = [];
        try {
            const responsibleTeamDataResponse = await getJiraResponsibleTeam();
            responsibleTeamData = responsibleTeamDataResponse?.data?.values;
        } catch (error) {
            responsibleTeamData = [];
        }
        if (Array.isArray(responsibleTeamData)) {
            setResponsibleTeamList([...responsibleTeamData]);
        } else {
            setResponsibleTeamList([]);
        }
    }

    useEffect(() => {
        if (issueRefetch) {
            setTimeout(() => setIssueRefetch(false), 1000)
        }
        if (createdMeetingId) {
            setCreatedMeetingId(null);
        }
    }, [issueRefetch, createdMeetingId]);

    useEffect(() => {
        const jiraAccessToken = localStorage.getItem('jiraAccessToken');
        if (userDetails && jiraAccessToken && !responsibleTeamList.length) {
            getResponsibleTeamList();
        }
    }, [userDetails])

    return (
        <div className="issueDiv">
            <ResponsibleTeamContext.Provider value={responsibleTeamList}>
                <IssueFilterPage setIssueRefetch={setIssueRefetch} />
                <Split mode="vertical" style={{ height: 'calc(100% - 125px)' }} >
                    <IssueTablePage createdMeetingId={createdMeetingId} issueRefetch={issueRefetch} />
                    <IssueDetailsPage setIssueRefetch={setIssueRefetch} setCreatedMeetingId={setCreatedMeetingId} />
                </Split>
                <CreateDocumentation />
            </ResponsibleTeamContext.Provider>
        </div>
    )
}

export default IssuePage